export enum InboxRowType {
  voicemail = 'voicemail',
  callbackRequest = 'callbackRequest',
}
